import { Pipe, PipeTransform } from '@angular/core';
import * as isEmpty from 'lodash/isEmpty';

/**
 * Splits text based on a separator and removes any empty lines
 */
@Pipe({ name: 'split' })
export class SplitPipe implements PipeTransform {
	public transform(text: string, separator: string): string[] {
		return (text ?? '').split(separator).filter(item => !isEmpty(item.trim()));
	}
}
